import Layout from '@/components/Layout';
import { EventDetailView } from '@/components/events/EventDetailView';

const EventDetail = () => {
  return (
    <Layout>
      <EventDetailView />
    </Layout>
  );
};

export default EventDetail;
